import { plainToInstance, Type } from 'class-transformer'
import { TaskBase } from '@core/entities/task/TaskBase'
import { ITaskDraft } from '@core/entities/task/TaskDraft'
import { TemplateProjectLocations } from '@core/entities/template/TemplateProjectLocations'

export class TaskDraft extends TaskBase<ITaskDraft> {
  draftName: string
  projectId: number

  @Type(() => TemplateProjectLocations)
  projectLocations?: TemplateProjectLocations

  public static new(payload: unknown): TaskDraft {
    const entity = plainToInstance(TaskDraft, payload)

    return entity
  }
}
